import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Input from 'components/form/Input';
import Select from 'components/form/Select';
import Form from 'components/form';
import Button from 'components/common/Button';
import STATES from 'constant/states';
import Box from '@material-ui/core/Box';
import { useMutation } from 'react-apollo';
import { ADD_ADDRESS, GET_ADDRESS } from 'graphql/parent';
import useSnack from '../../../hooks/useSnack';

const FormItem = Form.FormItem;

const AddressFrom = ({ form, onNext, onBack }) => {
  const [saveAddress] = useMutation(ADD_ADDRESS);
  const snack = useSnack();
  const { getFieldDecorator, validateFields } = form;

  const onSave = () => {
    return validateFields().then(
      (values) => {
        return saveAddress({
          variables: {
            data: values
          },
        })
          .then(() => onNext())
          .catch(e => snack.error(e.message));
      }
    )
  }

  return (
    <>
      <Typography gutterBottom variant="subtitle1">Your home address</Typography>
      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <FormItem>
            {getFieldDecorator('address1', {
              rules: [
                {
                  required: true,
                  message: 'Please enter your address',
                },
              ],
            })(<Input label="Address line 1" />)}
          </FormItem>
        </Grid>
        <Grid item md={6} xs={12}>
          <FormItem>
            {getFieldDecorator('address2')(<Input label="Address line 2" />)}
          </FormItem>
        </Grid>
        <Grid item md={4} xs={6}>
          <FormItem>
            {getFieldDecorator('city', {
              rules: [
                {
                  required: true,
                  message: 'Please enter city',
                },
              ],
            })(<Input label="City" />)}
          </FormItem>
        </Grid>
        <Grid item md={4} xs={6}>
          <FormItem>
            {getFieldDecorator('state', {
              rules: [
                {
                  required: true,
                  message: 'Please enter state',
                },
              ],
            })(<Select transformValue isMulti={false} options={STATES} label="State" />)}
          </FormItem>
        </Grid>
        <Grid item md={4} xs={6}>
          <FormItem>
            {getFieldDecorator('zip', {
              rules: [
                {
                  required: true,
                  message: 'Please enter zip code',
                },
              ],
            })(<Input label="Zip code" type="number" />)}
          </FormItem>
        </Grid>
       <Grid item xs={12}>
         <Box display="flex" justifyContent="space-between" marginBottom={1}>
           <Button color="primary" onClick={onBack}>
             Back
           </Button>
           <Button
             size="large"
             variant="contained"
             color="primary"
             onClick={onSave}
           >
             Submit
           </Button>
         </Box>
       </Grid>
      </Grid>
    </>
  )
}

export default Form.create()(AddressFrom);